module.exports = __webpack_public_path__ + "static/img/stakeholdersTW.5f21a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stakeholdersTW.png
// module id = jQtX
// module chunks = 1